const IMG = '/images/daycare';

// These two filenames are swapped relative to their contents; aliased here by
// what they actually are. Renaming the files is a separate cleanup.
const TESTIMONIAL_CARD = `${IMG}/sample-menu.webp`;
const ACADEMY_LOGO = `${IMG}/testimonial.webp`;

const page = {
  slug: 'daycare',
  title: 'Children Meals at Daycare',
  hero: {
    title: 'Delicious & Healthy Meals for your Children at Daycare',
    subtitle: 'We deliver 5 days a week directly to your daycare. We can also deliver to your home.',
    subtitleBelow: true,
    image: `${IMG}/hero.webp`,
  },
  blocks: [
    {
      type: 'split',
      image: `${IMG}/menu.webp`,
      imageAlt: 'A tray of freshly prepared children’s meals',
      imageAspect: '1 / 1',
      imageSide: 'left',
      groups: [
        {
          heading: "Eating Well is Core to Every Child's Well-Being and Education",
          paragraphs: [
            'We are a Brooklyn-based healthy meal delivery service started by a Park Slope mom who was looking for food that would fuel her and her family the right way. Our meals are made fresh from scratch using seasonal, high quality ingredients, change weekly, and contain no added sugar (unless baked goods), small amounts of salt, small amounts of high quality oils.',
            'About a year ago, a neighborhood mom reached out asking if we could make meals for her child in daycare. Not only was this very aligned with our mission to make it easy to eat well but also with the idea that eating well is something that should be learned early on. So we said yes!',
          ],
        },
      ],
    },
    // Plan beside the testimonials, so Subscribe and the social proof share a screen.
    {
      type: 'split',
      tone: 'warm',
      // A graphic with words in it — show it whole rather than cropped.
      variant: 'whole',
      image: TESTIMONIAL_CARD,
      imageAlt: 'Two testimonials from daycare parents, Layale and Amanda',
      imageSide: 'right',
      groups: [
        {
          heading: 'Our Daycare Weekly Plan',
          rule: true,
          headingSize: 'clamp(28px, 3vw, 38px)',
          paragraphs: [],
        },
      ],
      card: {
        variant: 'plain',
        title: 'Daycare Weekly Meal Plan: Lunch + 2 Snacks per day',
        price: 'from $59.00 every week',
        lines: [
          'This plan includes: Daily Lunch, 2 Daily Snacks',
          'Delivery options: Daily to Daycare (need a minimum of 8 children), Daily to Home or Daycare, Once or Twice a Week to Home or Daycare',
        ],
        image: `${IMG}/card-weekly-plan.webp`,
        imageAlt: 'A smiling toddler eating a Square Fare meal at daycare',
        cta: {
          label: 'Subscribe',
          href: 'https://www.getsquarefare.com/this-weeks-meals/p/tailored-meals-a4hy3-s4fng-dee9f-px65n-8nes4-dd9gr-gr8cw-7m7xy-l885e-w4g9r-pwshw-mjsds-3wy33-dz859-fh39d-2t57k-9gx4t-jgewd',
        },
      },
    },
    { type: 'heading', text: 'Sample Menu', align: 'center', rule: true },
    {
      type: 'shapes',
      items: [
        {
          heading: 'MONDAY',
          lines: [
            'LUNCH: Quesadilla, Bean Salad, Diced Tomatoes',
            'SNACK 1: Cheerios & Dried Fruit',
            'SNACK 2: Overnight Oats & Fresh Fruit',
          ],
        },
        {
          heading: 'TUESDAY',
          lines: [
            'LUNCH: Ginger Salmon, Brown Rice, Steamed Spinach, Roasted Fennel',
            'SNACK 1: Cheese and Crackers',
            'SNACK 2: Seasonal Fruit Salad',
          ],
        },
        {
          heading: 'WEDNESDAY',
          lines: [
            'LUNCH: Beef Bolognese, Pasta, Broccoli and Steamed Carrots',
            'SNACK 1: Cheerios & Dried Fruit',
            'SNACK 2: Homemade Cake',
          ],
        },
        {
          heading: 'THURSDAY',
          lines: [
            'LUNCH: Caribbean Chicken with Zucchini, Mushrooms and Sweet Potato',
            'SNACK 1: Homemade Bean Dip with Cucumber',
            'SNACK 2: Seasonal Fruit Salad',
          ],
        },
        {
          heading: 'FRIDAY',
          lines: [
            'LUNCH: Tamari Tofu with Japanese Eggplant, Red Pepper, Butternut Squash',
            'SNACK 1: Cheese and Crackers',
            'SNACK 2: Overnight Oats & Fresh Fruit',
          ],
        },
      ],
    },
    // Claire: "big, bold, playful" — the display band, not a body-size line.
    {
      type: 'text',
      variant: 'display',
      tone: 'warm',
      paragraphs: ['We would love to cook for your children!'],
    },
    {
      type: 'columns',
      items: [
        {
          heading: 'Contact Us:',
          rule: true,
          paragraphs: [
            'Claire Goldwiz',
            [{ label: '(917) 679-5306', href: 'tel:+19176795306' }],
            [{ label: 'claire@getsquarefare.com', href: 'mailto:claire@getsquarefare.com' }],
          ],
        },
        {
          heading: 'Ask About Us:',
          rule: true,
          image: ACADEMY_LOGO,
          imageAlt: "Amy's Academy Preschool & Playgroup logo",
          paragraphs: [
            ['Contact: Ms Kay at ', { label: '(718) 462-3200', href: 'tel:+17184623200' }],
          ],
        },
      ],
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Contact Us', to: '/contact-form-general' },
        { label: 'Visit FAQ', to: '/faqs'},
      ],
    },
  ],
};

export default page;
